import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import '@fontsource/dm-sans';

declare module '@mui/system' {
  interface Theme {
    status: {
      warning: string;
    };
  }
}

export const liivelyTheme = createTheme({
  palette: {
    background: {
      paper: '#fff',
    },
    text: {
      primary: '#173A5E',
      secondary: '#46505A',
    },
    action: {
      active: '#001E3C',
    },
  },
});

/**
 * @deprecated
 */
export const customTheme = {
  fontFamily: 'DM Sans',
  background: '#F3F3F3',
  screen: {
    width: '500px',
  },
};
